import React from 'react'
import styled from 'styled-components'
import { Redirect } from 'react-router-dom'
import { withApollo } from 'react-apollo'
import { message, Row, Col } from 'antd'

import SetPasswordsFirstTime from '../../../components/user/SetPasswordsFirstTimeA1'
import { setToken, isLoggedIn } from '../../../utils/auth'
import { Mutations } from '../../../graphql'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import FooterLogin from '../../../components/user/FooterLogin'

const BackgroundDiv = styled.div`
	// height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
`

const FormDiv = styled.div`
	padding: 50px 100px;
	box-shadow: 30px 40px 40px 1px rgba(0, 0, 0, 0.15), 0 0px 0px rgba(0, 0, 0, 0.25);
	border-radius 20px;
	background-color: #fff;
`

class Login extends React.PureComponent {
	state = {

		//////////////////////addmodalINTERNAL_SERVER_ERROR
		showModalErrors: false
	}
	onSubmit = async ({ username, password, remember }) => {
		try {
			const { client } = this.props
			const { data, errors } = await client.mutate({
				mutation: Mutations.login,
				variables: {
					username,
					password,
					notificationInfo: {
						deviceUid: '',
						notificationToken: ''
					},
					deviceInfo: {
						platform: window.navigator.platform
					}
				}
			})
			//////////////////////addmodalINTERNAL_SERVER_ERROR
			if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
				await this.setState({
					showModalErrors: true
				})
			}
			setToken(data.login, remember)
			window.location.href = '/'
		} catch (error) {
			// const errorMessage = error.graphQLErrors[0].message
			// message.error(errorMessage)
		}
	}

	render() {
		if (isLoggedIn()) {
			return <Redirect to="/" />
		}
		return (
			<div style={{
				// height: "100vh",
				// backgroundImage: `url(${require("../../../assets/images/BGLogin.jpg")})`,
				backgroundPosition: 'center',
				// backgroundSize: 'cover',
				// backgroundRepeat: 'no-repeat'
			}}>
				<BackgroundDiv>
					<Row>
						<Col>
							<FormDiv className="p-5-moblie mt-5 formDiv">
								{/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
								{
									this.state.showModalErrors &&
									<ModalErrors />
								}
								{/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
								<SetPasswordsFirstTime autoFocus afterSubmit={this.onSubmit} />
							</FormDiv>
						</Col>
						<Col className="mt-4">
							<FooterLogin></FooterLogin>
						</Col>
					</Row>
					
					
				</BackgroundDiv>
			</div>
		)
	}
}

export default withApollo(Login)
